export default "__VITE_ASSET__CpdZ1O_Z__"